// Constants
export const SET_THEME = 'APP__SET_THEME';
export const TOGGLE_SIDEBAR = 'APP__TOGGLE_SIDEBAR';
export const CLEAN = 'APP__CLEAN';
export const SET_CORTE = 'APP__SET_CORTE';
export const SET_VISIBLE_MODAL_PERIODO_FISCAL = 'APP__SET_VISIBLE_MODAL_PERIODO_FISCAL';
export const SET_SOCKETS_CONNECTED = 'APP__SET_SOCKETS_CONNECTED';
export const SET_VISIBLE_MODAL_CORTE = 'APP__SET_VISIBLE_MODAL_CORTE';
export const SET_GPM_TIMELINE_OPEN = 'APP__SET_GPM_TIMELINE_OPEN';
export const SET_AVAILABLE = 'APP__SET_AVAILABLE';

const initialState = {
  collapsedSidebar: false,
  theme: {},
  corte: null,
  visibleModalPeriodoFiscal: false,
  socketsConnected: false,
  visibleModalCorte: false,
  GPMTimelineOpen: true,
  available: true,
};

// Action handlers
const clean = () => ({ ...initialState });
const toggleSidebar = (state, payload) => ({ ...state, collapsedSidebar: payload });
const setTheme = (state, payload) => ({ ...state, theme: { ...payload } });
const setCorte = (state, payload) => ({ ...state, corte: payload });
const setVisibleModalPeriodoFiscal = (state, payload) => (
  { ...state, visibleModalPeriodoFiscal: payload });
const setSocketsConnected = (state, payload) => ({ ...state, socketsConnected: !!payload });
const setVisibleModalCorte = (state, payload) => ({ ...state, visibleModalCorte: payload });
const setGBPTimelineOpen = (state, payload) => ({ ...state, GPMTimelineOpen: payload });
const setAvailableApp = (state, payload) => ({ ...state, available: payload });

const ACTION_HANDLER = {
  [SET_THEME]: setTheme,
  [TOGGLE_SIDEBAR]: toggleSidebar,
  [SET_CORTE]: setCorte,
  [CLEAN]: clean,
  [SET_VISIBLE_MODAL_PERIODO_FISCAL]: setVisibleModalPeriodoFiscal,
  [SET_SOCKETS_CONNECTED]: setSocketsConnected,
  [SET_VISIBLE_MODAL_CORTE]: setVisibleModalCorte,
  [SET_GPM_TIMELINE_OPEN]: setGBPTimelineOpen,
  [SET_AVAILABLE]: setAvailableApp,
};

export default (state = initialState, action) => {
  const handler = ACTION_HANDLER[action.type];
  return handler ? handler(state, action.payload) : state;
};
